// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MttrSlaIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 9.14a5.73 5.73 0 1 0 .01 11.45A5.73 5.73 0 0 0 12 9.14m0 10a4.3 4.3 0 1 1 .01-8.58 4.3 4.3 0 0 1-.01 8.59"
    />
    <path
      fill="currentColor"
      d="M14.14 14.14h-1.43V12a.71.71 0 1 0-1.42 0v2.86c0 .4.32.71.71.71h2.14a.71.71 0 1 0 0-1.43"
    />
    <path
      fill="currentColor"
      d="M16.1 6.98c-1.9-1.64-3.54-3.06-3.39-5.66a.71.71 0 0 0-1.1-.64C9.9 1.81 8.18 3.4 7.8 6.61l-1.06-.88a.72.72 0 0 0-1.17.55c0 1.98-.49 2.95-1 3.97-.56 1.13-1.15 2.3-1.15 4.6a8.59 8.59 0 0 0 17.16 0c0-4-2.38-6.05-4.48-7.87M12 22a7.16 7.16 0 0 1-7.15-7.15c0-1.98.49-2.94 1-3.97.43-.86.87-1.75 1.06-3.16l1.06.89a.72.72 0 0 0 1.17-.55c0-2.7.85-4.23 2.2-5.41.39 2.43 2.13 3.94 3.82 5.4 2.05 1.77 3.99 3.45 3.99 6.8 0 3.94-3.2 7.15-7.15 7.15"
    />
  </svg>,
  "MttrSla",
);
export default MttrSlaIcon;
